<mat-form-field [cmIsLoading]="!$options()">
    <mat-label>{{ $label() }}</mat-label>
    <mat-select
        name="tags"
        placeholder="Tags"
        multiple
        [ngModel]="$assigned()"
        [ngModelOptions]="{standalone: true}"
        [disabled]="!$options()?.length || !$canEdit()"
        [compareWith]="compareAssignments"
    >
        @for (tag of $options(); track tag.id) {
            <mat-option (onSelectionChange)="toggleTag($event)" [value]="tag">{{ tag.name }} </mat-option>
        }
    </mat-select>
</mat-form-field>
